module.exports = __webpack_public_path__ + "img/logo_wartaekonomi.93b46880.png";